import { getQuestionObj, getTotalObj } from '../api/common';
import { getStepResultText, getDimensionResultText } from '../api/resultTexts';

function toEmail(user, questions, dimensions, answers, IMAGES) {
    const greetingsHtml = `
    <p>Olá, ${user.diagnostic_name}</p>
    <p>Obrigado por responder o questionário de maturidade da cadeia de valor a partir de uma perspectiva dos processos S&OP e S&OE.</p>
    <p>Abaixo, seu resultado:</p>
    `

    const userHtml = `
    <p>${user.diagnostic_name}</p>
    <p>${user.diagnostic_number}</p>
    <p>${user.diagnostic_email}</p>
    <p>${user.diagnostic_company}</p>
    <p>${user.diagnostic_url}</p>
    <p>${user.diagnostic_office}</p>
    <p>${user.diagnostic_area}</p>
    `

    const questionsHtml = questions.map(q => {
        const { error, order, title, answer } = getQuestionObj(questions, answers, q.order);
        if (error) {
            return `<p>${error}</p>`
        } else {
            return `<p>${order}) ${title}: ${answer}</p>`
        }
    });

    const stepsHtml = ["S&OP", "S&OE"].map(s => {
        const totals = getTotalObj(s, null, questions, answers);
        const textObj = getStepResultText(s, totals.percentage);
        return `<hr/><div style='display:flex;justify-content:left;'>
        <span style='padding:10px 10px 0 0;'>Processo: </span> <span style='padding:10px 0 0 10px;'>${totals.title}</span></div>
        <p>${totals.total}/${totals.outOf} (${totals.percentage}%)</p>
        <p>Nível: ${textObj.level}</p> <p>Resultado: ${textObj.result}</p> <p>Recomendações: ${textObj.advice.map((a, i) => `${a}`).join('')}
        `
    });

    const dimensionsHtml = dimensions.map(d => {
        const totals = getTotalObj(null, d, questions, answers);
        const textObj = getDimensionResultText(d, totals.percentage);
        return `<hr/><div style='display:flex;justify-content:left;'>
        <span style='padding:10px 10px 0 0;'>Dimensão: </span> <span style='padding:10px 0 0 10px;'>${totals.title}</span></div>
        <p>${totals.total}/${totals.outOf} (${totals.percentage}%)</p>
        <p>Nível: ${textObj.level}</p> <p>Resultado: ${textObj.result}</p> <p>Recomendações: ${textObj.advice}
        `
    })

    const templateAdminHtml =
        `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Resultado</title>
</head>
<body id="report">
<hr/>
<h3>Perfil</h3>
${userHtml}
<hr/>
<h3>Respostas</h3>
${questionsHtml.join('')}
<hr/>
<h3>Resultado</h3>
${stepsHtml.join('')}
${dimensionsHtml.join('')}
</body>
</html>
`

    const templateUserHtml =
        `
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Resultado</title>
</head>
<body id="report">
${greetingsHtml}
<hr/>
<div style='display:flex;flex-direction:row;justify-content:left;align-items:center;'>
<h3>Resultado</h3>
</div>
${stepsHtml.join('')}
${dimensionsHtml.join('')}
</body>
</html>
`
    return {
        adminTo: 'contato@tecemos.com',
        userTo: user.diagnostic_email,
        cc: '',
        toName: 'Admin Tecemos',
        subject: `Questionário de ${user.diagnostic_name}`,
        adminHtml: templateAdminHtml,
        userHtml: templateUserHtml,
    }
}

export { toEmail }